import { Stack } from '@mui/system'
import ResettableTextField from '../../../reservation-insert/components/resettable-text-field'
import { ReservationGroupUpsertGridRow, isReservationGroupUpsertGridTotalRow, ReservationGroupUpsertGridTotalRow, ReservationGroupUpsertGridRowGroupingInfo } from '../reservation-group.types'
import { CircularProgress } from '@mui/material'

type ReservationGroupUpsertAveragePriceFieldProps = {
  row: ReservationGroupUpsertGridRow | ReservationGroupUpsertGridTotalRow
  updateRowTotalPrice: (groupingInfo: ReservationGroupUpsertGridRowGroupingInfo, rowId: string, newPrice: number) => void
  updateTotalRowTotalPrice: (initialValue: number, value: number) => void
  loading: boolean
}

export default function ReservationGroupUpsertAveragePriceField(props: ReservationGroupUpsertAveragePriceFieldProps) {
  const { row /* : propsRow */, updateTotalRowTotalPrice, updateRowTotalPrice, loading } = props
  const isTotalRow = isReservationGroupUpsertGridTotalRow(row)

  // console.log(row)
  // useEffect(() => {
  //   const check = async () => {
  //     if (!isTotalRow) {
  //       console.log('calculateAveragePrice')
  //       const price = await calculateAveragePrice(row)
  //       console.log('price', price, row.initialAveragePrice, row)
  //       if (price !== undefined && price !== row.initialAveragePrice) {
  //         updateRowInitialPrice(row.groupingInfo, row.id, price)
  //       }
  //     }
  //   }
  //   check()
  // }, [])

  if (!row) return <CircularProgress size={18} sx={{ color: 'var(--RichElectricBlue)' }} />
  if (isTotalRow) {
    const totalRow = row as ReservationGroupUpsertGridTotalRow
    return (
      <Stack direction="row" justifyContent="flex-end" alignItems="center" width="100%">
        <ResettableTextField
          disabled={loading || totalRow.disablePrices}
          changeOnBlur
          initialValue={totalRow.initialAveragePrice}
          min={0}
          value={row.averagePrice}
          onChange={(value) => updateTotalRowTotalPrice(totalRow.initialTotalPrice, value ? value * totalRow.nights : 0)}
          resetPosition={'LEFT'}
        />
      </Stack>
    )
  } else {
    const averageRow = row as ReservationGroupUpsertGridRow
    return (
      <Stack direction="row" justifyContent="flex-end" alignItems="center" width="100%">
        <ResettableTextField
          disabled={loading}
          changeOnBlur
          initialValue={row.initialAveragePrice}
          min={0}
          value={row.averagePrice}
          onChange={(value) => updateRowTotalPrice(averageRow.groupingInfo, averageRow.id, value ? value * row.nights : 0)}
          resetPosition={'LEFT'}
        />
      </Stack>
    )
  }
}
